import { AccountFiscalService } from '../../../../services/AccountFiscalService';

const countriesTaxesManipulation = (countriesTaxes, intl) => {
  const countriesToAdd = [
    { name: 'Portugal - Açores', country_code: 'PT-AC' },
    { name: 'Portugal - Madeira', country_code: 'PT-MA' },
  ];

  const portugalIndex = countriesTaxes.findIndex(
    (country) => country.name === 'Portugal'
  );

  if (portugalIndex !== -1) {
    const portugalChanged = countriesTaxes[portugalIndex];
    portugalChanged.name = 'Portugal - Continental';

    const portugalBlock = [portugalChanged, ...countriesToAdd];

    countriesTaxes.splice(portugalIndex, 1, ...portugalBlock);
  }

  countriesTaxes.forEach((element) => {
    if (element.country_code === null) {
      const countryName = element.name.split(' ');
      let initials = '';
      countryName.forEach((word) => {
        initials += word.charAt(0);
      });
      element.country_code = initials;
    }
  });

  countriesTaxes.push({
    name: intl.messages['taxesUnknownRegion'],
    country_code: null,
  });

  const result = countriesTaxes.map((country) => {
    return { name: country.name, region: country.country_code };
  });

  return result;
};

const handleTaxValues = async (taxes) => {
  const accountSettings = await AccountFiscalService.getAccountSettings();

  const decimalMarker = accountSettings.account.decimal_marker;

  const result = taxes.map((tax) => {
    return {
      ...tax,
      value:
        parseFloat(tax.value).toFixed(2).replace('.', decimalMarker) + ' %',
    };
  });

  return result;
};

const taxCodes = (intl) => {
  const codes = ['NOR', 'INT', 'RED', 'ISE', 'OUT'];

  const taxesCodes = codes.map((code) => {
    return { code: code, name: intl.messages[`taxesCode${code}`] };
  });

  return taxesCodes;
};

export const TaxesHelper = {
  countriesTaxesManipulation,
  handleTaxValues,
  taxCodes,
};
